import { css, jsx } from '@emotion/core';
import { Icon } from 'antd';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { bp, colors } from '@/styles';

const styleHelpers = {
  nextDefault: css`
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    background-color: white;
    background-image: none;
    border-radius: 50%;
    height: 28px;
    width: 28px;
    border: 0.5px solid ${colors.primaryBlue};
    transform: translate(0px, -35px);
    @media ${bp.lg} {
      transform: translate(-20px, -40px);
      height: 40px;
      width: 40px;
    }
    &::after {
      display: none;
    }
  `,
  prevDefault: css`
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    background-color: white;
    background-image: none;
    border-radius: 50%;
    height: 28px;
    width: 28px;
    border: 0.5px solid ${colors.primaryBlue};
    transform: translate(0px, -35px);
    @media ${bp.lg} {
      transform: translate(20px, -40px);
      height: 40px;
      width: 40px;
    }
    &::after {
      display: none;
    }
  `,
};
const style = {
  title: css`
    margin-top: 24px;
    @media ${bp.md} {
      margin-top: 80px;
    }
  `,
  buttonIcon: css`
    color: ${colors.primaryBlue};
    font-size: 1.6rem;
    @media ${bp.lg} {
      font-size: 1.6rem;
    }
  `,
  buttonIconNext: css`
    color: ${colors.primaryBlue};
    font-size: 1.6rem;
    @media ${bp.lg} {
      font-size: 1.6rem;
    }
  `,
  wrapper: {
    default: css``,
    hero: css``,
    thumb: css`
      display: none;
      padding-top: 24px;
      @media ${bp.lg} {
        display: flex;
      }
      .swiper-slide {
        border: 5px solid transparent;
        cursor: pointer;
      }
      .swiper-slide-thumb-active {
        border-color: ${colors.primaryRed};
      }
    `,
    imageGallery: css``,
  },
  next: {
    default: styleHelpers.nextDefault,
    hero: css`
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
      background-color: white;
      background-image: none;
      border-radius: 50%;
      height: 28px;
      width: 28px;
      transform: translate(0px, -35px);
      @media ${bp.lg} {
        transform: translate(-150px, -10px);
      }
    `,
    thumb: css``,
    imageGallery: styleHelpers.nextDefault,
  },
  prev: {
    default: styleHelpers.prevDefault,
    hero: css`
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
      background-color: white;
      background-image: none;
      border-radius: 50%;
      height: 28px;
      width: 28px;
      transform: translate(0px, -35px);
      @media ${bp.lg} {
        transform: translate(150px, -10px);
      }
    `,
    thumb: css``,
    imageGallery: styleHelpers.prevDefault,
  },
  pagination: css`
    span {
      height: 16px;
      width: 16px;
      border: 3px white solid;
      background-color: white;
    }
  `,
  paginationBullet: css``,
  'gallery-top': css`
    position: relative;
    overflow: hidden;
  `,
  infographics: css`
    position: relative;
    overflow: hidden;
  `,
};

class Carousel extends PureComponent {
  render() {
    const {
      children,
      containerClassName,
      below,
      showArrows,
      prevBtnClassName = '',
      nextBtnClassName = '',
      type,
    } = this.props;
    return (
      <div
        className={classnames('swiper-container', containerClassName)}
        css={containerClassName ? style[containerClassName] : null}
        ref={this.ref_swiper_container}
      >
        <div className="swiper-wrapper" css={style.wrapper[type]}>
          {React.Children.toArray(children).map(Child =>
            React.cloneElement(Child, {
              ...Child.props,
              className: classnames('swiper-slide', Child.props.className),
            })
          )}
        </div>
        {showArrows && (
          <>
            <div
              css={style.next[type]}
              className={classnames('swiper-button-next', nextBtnClassName)}
            >
              <Icon css={style.buttonIcon} type="right" />
            </div>
            <div css={[style.paginationBullet, style.pagination]} className="swiper-pagination" />
            <div
              css={style.prev[type]}
              className={classnames('swiper-button-prev', prevBtnClassName)}
            >
              <Icon css={style.buttonIcon} type="left" />
            </div>
          </>
        )}
        {below}
      </div>
    );
  }
}

Carousel.propTypes = {
  containerClassName: PropTypes.string.isRequired,
  below: PropTypes.node,
  showArrows: PropTypes.bool,
  nextBtnClassName: PropTypes.string,
  prevBtnClassName: PropTypes.string,
  type: PropTypes.oneOf(['imageGallery', 'hero', 'thumb', 'default']),
};

Carousel.defaultProps = {
  below: <></>,
  showArrows: true,
  nextBtnClassName: '',
  prevBtnClassName: '',
  type: 'default',
};

export default Carousel;
